import { createSelector } from 'reselect'

import { selectCurrentPayload } from 'selectors/location'

export default createSelector(selectCurrentPayload, payload => payload.id)
